import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinnavimumbaiairport() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Navi Mumbai Airport',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Navi Mumbai Airport',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Navi Mumbai Airport, ensuring smooth and timely transportation for corporate travelers, employees, clients, and top executives. Our fleet of executive sedans, SUVs, and premium vehicles offers a comfortable and stress-free airport commute for arrivals, departures, and connecting business travel. With experienced chauffeurs, flight-time coordination, 24/7 availability, and well-maintained vehicles, we deliver punctual, safe, and hassle-free mobility solutions. Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Navi Mumbai Airport.',

    top: 'Top Places to Visit in Navi Mumbai with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Navi Mumbai Airport Corporate Transfer",
"description": "Navi Mumbai Airport Corporate Transfer offers professional and reliable transportation services for corporate employees, executives, and business travelers to and from Navi Mumbai Airport. The service ensures punctual pickups, GPS-enabled vehicles, trained chauffeurs, and comfortable travel in sedans, SUVs, or shuttle vans, providing seamless airport commuting for corporate needs."
},
{
"name": "Airport Shuttle Navi Mumbai",
"description": "Airport Shuttle Navi Mumbai provides structured shuttle services for employees and staff traveling to and from Navi Mumbai Airport. With multi-passenger vans, trained drivers, GPS tracking, and scheduled pick-ups and drop-offs, the service ensures safe, organized, and timely transport for corporate groups."
},
{
"name": "Employee Airport Pickup Drop Navi Mumbai",
"description": "Employee Airport Pickup Drop Navi Mumbai offers daily airport commuting solutions for corporate employees. The service includes trained drivers, GPS-enabled vehicles, punctual pickups, structured routes, and comfortable seating to ensure smooth and reliable travel to and from Navi Mumbai Airport."
},
{
"name": "Corporate Airport Taxi Navi Mumbai",
"description": "Corporate Airport Taxi Navi Mumbai provides professional taxi services for business travelers, executives, and office staff commuting to and from the airport. The service features well-maintained sedans and SUVs, GPS monitoring, trained chauffeurs, and punctual pickups for hassle-free corporate travel."
},
{
"name": "Business Airport Cab Hire Navi Mumbai",
"description": "Business Airport Cab Hire Navi Mumbai offers dedicated airport cab services for corporate employees and executives. The service ensures timely pickups, trained drivers, GPS tracking, well-maintained vehicles, and comfortable travel for business trips and airport transfers."
},
{
"name": "Monthly Airport Cab Navi Mumbai",
"description": "Monthly Airport Cab Navi Mumbai provides long-term airport transport solutions for companies requiring consistent corporate travel. The service includes fixed monthly plans, professional drivers, GPS-enabled vehicles, structured schedules, and reliable airport pickups and drop-offs."
},
{
"name": "Best Corporate Airport Cabs Navi Mumbai",
"description": "Best Corporate Airport Cabs Navi Mumbai delivers premium airport transportation services for executives and corporate employees. The service features well-maintained sedans and SUVs, professional drivers, GPS monitoring, punctual pickups, and comfortable travel for stress-free airport commuting."
},
{
"name": "Outstation Airport Cab Navi Mumbai",
"description": "Outstation Airport Cab Navi Mumbai provides long-distance airport commuting solutions for business travelers and corporate employees. The service includes GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, punctual, and efficient travel."
},
{
"name": "Sedan Airport Cab Navi Mumbai",
"description": "Sedan Airport Cab Navi Mumbai offers premium sedans for executives and corporate travelers commuting to and from Navi Mumbai Airport. The service ensures professional drivers, GPS tracking, well-maintained vehicles, and comfortable seating for reliable airport transfers."
},
{
"name": "SUV Airport Cab Navi Mumbai",
"description": "SUV Airport Cab Navi Mumbai provides spacious and comfortable SUVs for team travel, executive transport, and corporate airport transfers. The service includes trained drivers, GPS-enabled vehicles, structured routes, and multi-passenger support for safe and efficient travel."
},
{
"name": "Airport Fleet Provider Navi Mumbai",
"description": "Airport Fleet Provider Navi Mumbai offers fully managed airport transportation solutions for corporate clients. The service includes a fleet of sedans, SUVs, and shuttles, trained drivers, GPS tracking, and well-coordinated schedules to ensure seamless and professional airport commuting."
},
{
"name": "Airport Staff Transportation Navi Mumbai",
"description": "Airport Staff Transportation Navi Mumbai delivers organized commuting solutions for office employees and staff traveling to and from the airport. The service ensures punctual pickups, trained chauffeurs, GPS-enabled vehicles, and structured routes for safe and efficient staff mobility."
},
{
"name": "Corporate Mobility Navi Mumbai Airport",
"description": "Corporate Mobility Navi Mumbai Airport provides end-to-end airport transportation services for corporate organizations. The service features well-maintained vehicles, trained drivers, GPS monitoring, structured schedules, and multi-passenger support to ensure safe, timely, and efficient airport travel."
},
{
"name": "Executive Airport Chauffeur Navi Mumbai",
"description": "Executive Airport Chauffeur Navi Mumbai delivers premium chauffeur-driven services for executives and VIPs traveling to and from Navi Mumbai Airport. The service ensures luxury sedans and SUVs, professional drivers, GPS tracking, timely pickups, and comfortable travel for high-profile corporate clients."
},
{
"name": "Company Airport Travel Navi Mumbai",
"description": "Company Airport Travel Navi Mumbai offers reliable airport transportation solutions for businesses. The service includes trained chauffeurs, GPS-enabled vehicles, structured schedules, and flexible fleet options to provide safe, efficient, and comfortable airport commuting for employees and corporate travelers."
}
],

"tableData": [
["Navi Mumbai Airport Corporate Transfer", "Airport Shuttle Navi Mumbai"],
["Employee Airport Pickup Drop Navi Mumbai", "Corporate Airport Taxi Navi Mumbai"],
["Business Airport Cab Hire Navi Mumbai", "Monthly Airport Cab Navi Mumbai"],
["Best Corporate Airport Cabs Navi Mumbai", "Outstation Airport Cab Navi Mumbai"],
["Sedan Airport Cab Navi Mumbai", "SUV Airport Cab Navi Mumbai"],
["Airport Fleet Provider Navi Mumbai", "Airport Staff Transportation Navi Mumbai"],
["Corporate Mobility Navi Mumbai Airport", "Executive Airport Chauffeur Navi Mumbai"],
["Company Airport Travel Navi Mumbai", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Navi Mumbai Airport",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable corporate cab services at Navi Mumbai Airport, ensuring smooth, timely, and comfortable airport transfers for employees and executives."
  },
  {
    "WhyChooseheading": "On-Time Airport Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual airport transfers, helping corporate travelers reach terminals on time for flights or return journeys without any delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Chauffeurs",
    "WhyChoosedescription": "Our skilled chauffeurs are trained in corporate protocol, ensuring safe, courteous, and disciplined travel for business professionals."
  },
  {
    "WhyChooseheading": "Premium & Well-Maintained Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, luxury cars, tempo travellers, and minibuses—clean, sanitized, and perfectly maintained for comfortable airport travel."
  },
  {
    "WhyChooseheading": "Customized Airport Travel Packages",
    "WhyChoosedescription": "We offer tailored cab rental plans for corporate airport transfers, ideal for business teams, executives, and visiting clients in Navi Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Airport Travel Assistance",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock for bookings, flight-based adjustments, and emergency travel requirements."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, ensuring a secure and comfortable airport commute."
  },
  {
    "WhyChooseheading": "Seamless Booking & Coordination",
    "WhyChoosedescription": "We streamline corporate airport travel with an easy booking process and efficient coordination, ensuring stress-free employee transportation."
  }
]


























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services for Navi Mumbai Airport?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for executives and employees traveling to and from Navi Mumbai Airport.',
  },
  {
    question: 'What types of corporate airport cab services are available?',
    answer: 'We provide airport pickups, drop-offs, round-trip services, VIP transfers, and dedicated corporate airport travel solutions.',
  },
  {
    question: 'Do you ensure timely airport transfers for corporate clients?',
    answer: 'Yes, our corporate cab services guarantee punctual airport pickups and drops with real-time tracking and optimized routes.',
  },
  {
    question: 'How can companies book corporate cab services for Navi Mumbai Airport?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for airport corporate cab services?',
    answer: 'We offer sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate requirements and passenger count.',
  },
  {
    question: 'Can multiple vehicles be booked for group airport transfers?',
    answer: 'Yes, Pune Corporate Cars India Private Limited can provide multiple vehicles for transporting large teams or VIP groups to and from the airport.',
  },
  {
    question: 'Are chauffeurs provided for airport corporate cab services?',
    answer: 'Absolutely. All airport cab services come with professional, trained chauffeurs to ensure a safe and comfortable ride.',
  },
  {
    question: 'What safety measures are followed for airport cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and experienced drivers.',
  },
  {
    question: 'What payment options are available for corporate airport cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for business clients.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Praveen Nair',
    feedback: 'Highly professional corporate cab service for Navi Mumbai Airport. Punctual, safe, and convenient for our team.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Sharma',
    feedback: 'Excellent service for airport transfers. Drivers are professional and vehicles are well-maintained for corporate travel.',
    rating: 5,
  },
];

































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Navi Mumbai Airport",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-navi-mumbai-airport.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services at Navi Mumbai Airport, including airport transfers, employee pickup & drop, corporate airport taxis, business travel cabs, monthly airport cab plans, outstation services, executive chauffeur-driven cars, and corporate fleet solutions for seamless airport mobility.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-navi-mumbai-airport"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Navi Mumbai Airport | Employee & Business Transfers</title>

  <meta
    name="description"
    content="Reliable corporate cab services at Navi Mumbai Airport including airport transfers, staff pickup & drop, corporate airport taxis, business and outstation travel, monthly airport cabs, executive chauffeur-driven cars, and corporate fleet services for companies in Navi Mumbai."
  />

  <meta
    name="keywords"
    content="Navi Mumbai Airport Corporate Transfer, Airport Shuttle Navi Mumbai, Employee Airport Pickup Drop Navi Mumbai, Corporate Airport Taxi Navi Mumbai, Business Airport Cab Hire Navi Mumbai, Monthly Airport Cab Navi Mumbai, Best Corporate Airport Cabs Navi Mumbai, Outstation Airport Cab Navi Mumbai, Sedan Airport Cab Navi Mumbai, SUV Airport Cab Navi Mumbai, Airport Fleet Provider Navi Mumbai, Airport Staff Transportation Navi Mumbai, Corporate Mobility Navi Mumbai Airport, Executive Airport Chauffeur Navi Mumbai, Company Airport Travel Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinnavimumbaiairport;